import React from "react";
import { Box, Button, Typography } from "@mui/material";

type ErrorBoundaryProps = {
	children: React.ReactNode;
};

type ErrorBoundaryState = {
	hasError: boolean;
};

export default class ErrorBoundary extends React.Component<
	ErrorBoundaryProps,
	ErrorBoundaryState
> {
	constructor(props: ErrorBoundaryProps) {
		super(props);
		this.state = { hasError: false };
		this.handleReset = this.handleReset.bind(this);
	}

	static getDerivedStateFromError(_: unknown): ErrorBoundaryState {
		return { hasError: true };
	}

	componentDidCatch(error: unknown, errorInfo: unknown) {
		// Replace with project-wide logger if available
		// eslint-disable-next-line no-console
		console.error("ErrorBoundary caught an error:", error, errorInfo);
	}

	handleReset() {
		this.setState({ hasError: false });
	}

	render() {
		if (this.state.hasError) {
			return (
				<Box
					role="alert"
					sx={{
						p: 2,
						color: "white",
						bgcolor: "#132f4c",
						border: "1px solid #265d97",
						borderRadius: 1,
					}}
				>
					<Typography variant="body2" sx={{ mb: 1 }}>
						Something went wrong while rendering this section.
					</Typography>
					<Button size="small" variant="outlined" onClick={this.handleReset}>
						Try again
					</Button>
				</Box>
			);
		}
		return this.props.children;
	}
}
